import { render, staticRenderFns } from "./DoubleStatusTableQueue.vue?vue&type=template&id=79a3abb7"
import script from "./DoubleStatusTableQueue.vue?vue&type=script&lang=js"
export * from "./DoubleStatusTableQueue.vue?vue&type=script&lang=js"
import style0 from "./DoubleStatusTableQueue.vue?vue&type=style&index=0&id=79a3abb7&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports